import { render, staticRenderFns } from "./BookerCommission.vue?vue&type=template&id=756cf344"
import script from "./BookerCommission.vue?vue&type=script&lang=js"
export * from "./BookerCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports